export const PRESET_PALETTES = [
  { name: 'Trust & Authority', colors: ['#0b2545', '#13315c', '#8da9c4', '#eef4ed', '#f4a259'] },
  { name: 'Warm & Welcoming', colors: ['#7f4f24', '#c97c5d', '#f2cc8f', '#f4f1de', '#3d405b'] },
  { name: 'Bold Energy', colors: ['#111111', '#ff3d00', '#ffb400', '#f5f5f5', '#2962ff'] },
  { name: 'Calm Wellness', colors: ['#2d6a4f', '#52b788', '#b7e4c7', '#f8f9f4', '#d4a373'] },
  { name: 'Luxury Noir', colors: ['#0d0d0d', '#1f1f1f', '#c9a227', '#f5f0e6', '#7a6a53'] },
  { name: 'Fresh & Playful', colors: ['#ff6b6b', '#ffd93d', '#6bcB77', '#4d96ff', '#fdfdfd'] },
  { name: 'Modern Tech', colors: ['#0f172a', '#6366f1', '#22d3ee', '#e2e8f0', '#f97316'] },
  { name: 'Earthy Natural', colors: ['#3a5a40', '#588157', '#a3b18a', '#dad7cd', '#bc6c25'] },
].map((p) => ({ ...p, colors: p.colors.map((c) => c.toLowerCase()) }));

export const PALETTE_LABELS = ['Primary', 'Secondary', 'Accent', 'Highlight', 'Support', 'Background', 'Text', 'Extra'];

export const FONT_PAIRS = [
  { name: 'Modern & Clean', heading: 'Outfit', body: 'Manrope' },
  { name: 'Elegant Luxury', heading: 'Playfair Display', body: 'Lora' },
  { name: 'Bold & Confident', heading: 'Montserrat', body: 'Open Sans' },
  { name: 'Editorial', heading: 'DM Serif Display', body: 'DM Sans' },
  { name: 'Friendly & Approachable', heading: 'Nunito', body: 'Nunito Sans' },
  { name: 'Tech / Startup', heading: 'Space Grotesk', body: 'IBM Plex Sans' },
  { name: 'Statement Maker', heading: 'Bebas Neue', body: 'Roboto' },
  { name: 'Classic Professional', heading: 'Merriweather', body: 'Source Sans 3' },
  { name: 'Warm Boutique', heading: 'Cormorant Garamond', body: 'Jost' },
  { name: 'Playful', heading: 'Fredoka', body: 'Quicksand' },
];

export const ALL_FONTS = [...new Set(FONT_PAIRS.flatMap((p) => [p.heading, p.body]).concat(['Poppins', 'Raleway', 'Libre Baskerville', 'Work Sans', 'Archivo Black', 'Oswald']))].sort();

export function loadGoogleFonts(fonts = ALL_FONTS) {
  const id = `wv-gf-${fonts.join('-').replace(/[^a-zA-Z0-9-]/g, '').slice(0, 120)}`;
  if (!fonts.length || document.getElementById(id)) return;
  const fam = fonts.map((f) => `family=${f.replace(/ /g, '+')}:wght@400;700`).join('&');
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?${fam}&display=swap`;
  document.head.appendChild(link);
}

export function readableOn(hex) {
  const h = (hex || '#000000').replace('#', '');
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? '#0A0F1C' : '#FFFFFF';
}

export function domainOf(url) {
  try { return new URL(url).hostname.replace(/^www\./, ''); } catch { return url; }
}

export function normalizeUrl(u) {
  const t = (u || '').trim();
  if (!t) return '';
  return /^https?:\/\//i.test(t) ? t : `https://${t}`;
}
